<template>
  <div>
    <Layout :pagetitle="$t('Partner Levels')">
      <div class="card">
        <div class="card-header">
          <div>
            <b-row>
              <b-col md="6">
                <h4 class="card-title" v-html="$t('Partner Levels')" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="card-body">
          <div>
            <b-row>
              <div class="col-md-3">
                <span>
                  <label>{{ $t('Search') }}</label>
                  <b-form-input v-model="search" type="text" id="search-table-input" :placeholder="$t('Search')" />
                </span>
              </div>
              <div class="col-md-3">
                <span>
                  <label>{{ $t('Sub Brand') }}</label>
                  <subBrandsSelector :mode="'single'" :modelValue="idSubBrand" @onChange="setSubBrand" />
                </span>
              </div>
              <div class="col-md-3" />
              <div class="col-md-3">
                <div class="d-flex justify-content-end">
                  <label>&nbsp;</label>
                  <div class="table-buttons mt-4 pt-1">
                    <button @click="createPartnerLevel" class="btn btn-primary">
                      {{ $t('Create') }}
                    </button>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row>
              <b-col>
                <Table
                  :title="''"
                  :items="partnerLevels"
                  :columns="columns"
                  :totalItems="totalItems"
                  :showButtons="true"
                  :searchable="false"
                  :isCard="false"
                  :editable="true"
                  :editLabel="$t('View')"
                  :removable="true"
                  :showPagination="true"
                  @onSearch="onSearch"
                  @onEdit="editPartnerLevel"
                  @onCreate="createPartnerLevel"
                  @onRemove="onRemove"
                  @onChangePage="changePage"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';

export default {
  components: { Layout, Table, subBrandsSelector },
  data() {
    return {
      search: '',
      page: 1,
      idSubBrand: null,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'sub_brand_name',
          label: this.$t('Sub Brand')
        },
        {
          key: 'level',
          label: this.$t('Level')
        }
      ],
      partnerLevels: []
    };
  },
  mounted() {
    this.getPartnerLevels();
    this.enableSearch();
  },
  methods: {
    setSubBrand(id = null) {
      this.idSubBrand = id;
      this.onSearch(this.search);
    },
    changePage(page) {
      this.page = page;
      this.getPartnerLevels();
    },
    onRemove(partnerLevel) {
      this.$api.destroy(`api/partnerLevel/${partnerLevel.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('PartnerLevel was excluded with success')
        });
        this.getPartnerLevels();
      });
    },
    getPartnerLevels() {
      this.$store.commit('SET_LOADING', true);

      let payload = { search: this.search, page: this.page };

      if (this.idSubBrand) {
        payload['idSubBrand'] = this.idSubBrand;
      }

      this.$api
        .get('api/partnerLevel', payload)
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.partnerLevels = (res.data?.results || []).map((pl) => {
            return {
              ...pl,
              sub_brand_name: pl.sub_brand?.name
            };
          });
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createPartnerLevel() {
      this.$router.push({
        name: 'partnerLevelCreate'
      });
    },
    editPartnerLevel(partnerLevel) {
      this.$router.push({
        name: 'partnerLevelUpdate',
        params: {
          id: partnerLevel.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getPartnerLevels();
    },
    enableSearch() {
      let input_search = document.getElementById('search-table-input');
      input_search.addEventListener(
        'keyup',
        this.$utils.debounce(() => {
          this.onSearch(this.search);
        })
      );
    }
  }
};
</script>

<style></style>
